import type {
  CompleteLoginSuccessResponse,
  LoginFormPayload,
  LoginSuccessResponse,
  PasswordResetLinkPayload,
  RegistryFormPayload,
  SMSLoginFormPayload,
  SMSSendPayload,
  ChangeRegistryPhonePayload,
  ResetPasswordPayload,
} from '@/types/auth'
import axios from 'axios'
import { DEFAULT_CHIEF_PATH, DEFAULT_ADMIN_PATH } from '@/constants/axios'

const refreshClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
})

export const loginApiCall = async (
  abortController?: AbortController,
  params?: LoginFormPayload,
): Promise<LoginSuccessResponse> => {
  const { data } = await axios.post(
    `${DEFAULT_CHIEF_PATH}/login`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const smsLoginApiCall = async (
  abortController?: AbortController,
  params?: SMSLoginFormPayload,
): Promise<CompleteLoginSuccessResponse> => {
  const { data } = await axios.post(
    `${DEFAULT_CHIEF_PATH}/auth/complete`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const registryApiCall = async (
  abortController?: AbortController,
  params?: RegistryFormPayload,
) => {
  const { data } = await axios.post(
    `${DEFAULT_CHIEF_PATH}/registration`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const sendSMSApiCall = async (
  abortController?: AbortController,
  params?: SMSSendPayload,
) => {
  const { data } = await axios.post(
    `${DEFAULT_CHIEF_PATH}/send-code`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const passwordResetLinkApiCall = async (
  abortController?: AbortController,
  params?: PasswordResetLinkPayload,
) => {
  const { data } = await axios.post(
    `${DEFAULT_CHIEF_PATH}/password-reset-link`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const changeRegistryPhoneApiCall = async (
  abortController?: AbortController,
  params?: ChangeRegistryPhonePayload,
) => {
  const { data } = await axios.post(
    `${DEFAULT_CHIEF_PATH}/registration/change-phone`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const logoutApiCall = async (abortController?: AbortController) => {
  const { data } = await axios.get(`${DEFAULT_CHIEF_PATH}/logout`, {
    signal: abortController?.signal,
  })
  return data
}

export const resetPasswordApiCall = async (
  abortController?: AbortController,
  params?: ResetPasswordPayload,
) => {
  const { data } = await axios.post(`${DEFAULT_CHIEF_PATH}/password-reset`, params, {
    signal: abortController?.signal,
  })
  return data
}

export const refreshApiCall = async (tokenHeader: string): Promise<CompleteLoginSuccessResponse> => {
  const { data } = await refreshClient.get(`${DEFAULT_CHIEF_PATH}/refresh`, { headers: {
    Authorization: tokenHeader,
  } })
  return data
}

export const adminLoginApiCall = async (
  abortController?: AbortController,
  params?: LoginFormPayload,
): Promise<LoginSuccessResponse> => {
  const { data } = await axios.post(
    `${DEFAULT_ADMIN_PATH}/login`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const adminSMSLoginApiCall = async (
  abortController?: AbortController,
  params?: SMSLoginFormPayload,
): Promise<CompleteLoginSuccessResponse> => {
  const { data } = await axios.post(
    `${DEFAULT_ADMIN_PATH}/auth/complete`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const adminSendSMSApiCall = async (
  abortController?: AbortController,
  params?: SMSSendPayload,
) => {
  const { data } = await axios.post(
    `${DEFAULT_ADMIN_PATH}/send-code`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data
}

export const adminLogoutApiCall = async (abortController?: AbortController) => {
  const { data } = await axios.get(`${DEFAULT_ADMIN_PATH}/logout`, {
    signal: abortController?.signal,
  })
  return data
}
